<body>
<footer>
    <div class="container mediaStyle">
        <a href="mailto:adityawiryamaulana@gmail.com">
            <i class="fa fa-envelope  mr-md-5 mr-3 fa-lg" aria-hidden="true"></i>
        </a>
        <a href="https://www.linkedin.com/in/aditya-wirya-maulana-a0714a1b2/">
            <i class="fa fa-linkedin  mr-md-5 mr-3 fa-lg" aria-hidden="true"></i>
        </a>
        <a href="https://www.instagram.com/adityawiryaa/">
            <i class="fa fa-instagram  mr-md-5 mr-3 fa-lg" aria-hidden="true"></i>
        </a>
        <a href="https://github.com/adityawiryaa?tab=repositories">
            <i class="fa fa-github  mr-md-5 mr-3 fa-lg" aria-hidden="true"></i>
        </a>
        <a href="https://api.whatsapp.com/send?phone=6281277864376&text=&source=&data=&app_absent=">
            <i class="fa fa-whatsapp  mr-md-5 mr-3 fa-lg" aria-hidden="true"></i>
        </a>
    </div>
    <div class="ownStyle">
        <p>
            &copy; 2020 Copyright : <a href="mailto:adityawiryamaulana@gmail.com">Created By Wirya Store</a>
        </p>
    </div>
</footer>
</body>